import ProfileEditContainer from "../../container/admin/profile-edit";

const ProfileEditView = () => {
    return <ProfileEditContainer />;
};

export default ProfileEditView; 